<template xmlns="http://www.w3.org/1999/html">
    <div class="login-full-a" id="category">
        <div class="body full-task-main">
            <div class="container">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <select class="form-control show-tick" id="categoryData" v-model="categoryIdSearch">
                        <label for="categories">Category</label>
                        <option value="">Please select</option>
                        <template v-for="(categoryData , index) in categoryArr">
                            <option :value="categoryData.value">{{categoryData.text}}</option>
                        </template>
                    </select>
                </div>
                <div class="clearfix"></div>
                <form id="categoryForm" enctype="multipart/form-data" method="post">
                    <!--<div class="form-group">-->
                    <!--<label for="mediaStatus">Media Status</label><br>-->
                    <!--<select class="form-control show-tick" id="mediaStatus" v-model="mediaStatus">-->
                    <!--<option value="" selected="selected">Please select</option>-->
                    <!--<option value="1">Verified</option>-->
                    <!--<option value="2">Not Verified</option>-->
                    <!--</select>-->
                    <!--</div>-->

                    <!--<div class="form-group">-->
                    <!--<label for="verifiedBy">Verified By</label>-->
                    <!--<div class="form-line">-->
                    <!--<input type="text" id="verifiedBy" name="verifiedBy" class="form-control"-->
                    <!--placeholder="Verified By" v-model="verifiedBy">-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <br/>
                        <vue-dropzone
                            id="drop1"
                            :options="dropzoneOptions"
                            ref="dropzone"
                            :headers="dropzoneOptions.headers"
                            @vdropzone-complete="afterComplete"
                            @vdropzone-removed-file="removedSelectedFile"
                            >
                        </vue-dropzone>
                        <font class="text-danger"> <strong id="errorMsg" class="error text-danger"></strong></font>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <br/>
                        <div class="form-group">
                            <label for="mediaSource">Media Source</label>
                            <div class="form-line">
                                <input type="text" id="mediaSource" name="mediaSource" class="form-control"
                                       placeholder="Enter Media Source" v-model="mediaSource">
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="submitFile()"></input>
                            <button class="btn btn-primary" type="button" @click="removeAllFiles">Remove File</button>
                        </div>
                    </div>

                </form>    
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        mixins: [SessioMixin],
        components: {
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                dropzoneOptions: {
                    timeout: 3000000,
                    url: "https://httpbin.org/post",
                    method: 'POST',
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                },
                categoryData: '',
                categoryArr: [],
                mediaSource: "",
//                categoryId : "",
                categoryIdSearch: "",
                verifiedBy: "",
                dataURL: "",
                mediaStatus: "",
                imagesURL: [],
                imagesType: [],
                imagesSize: [],
                videos: '',
                videoFile: '',
                oneFileUpload: false,
            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.MenuClose();
            self.loadCategory();
        },

        methods: {
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.oneFileUpload = false;
            },

            removedSelectedFile(file, xhr, error) {
                self.removedFile = true;
                self.videoFile = file;
                self.oneFileUpload = false;
            },

            afterComplete(file) {
                if (self.oneFileUpload == false) {
                    self.videoFile = file;
                    self.oneFileUpload = true;
                } else {
                    self.$refs.dropzone.removeFile(file);
                    self.errorMsg = "Only one file allowed";
                    $("#errorMsg").html(self.errorMsg);
                    return false;
                }
            },
            loadCategory() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            submitFile() {
                /* need to verify where it is used*/
                var form = $('#categoryForm')[0];
                var data = new FormData(form);
                data.append('file', self.videoFile);
                data.append('categoryId', self.categoryIdSearch);
                data.append('mediaSource', self.mediaSource);
                data.append('mediaStatus', self.mediaStatus);
                data.append('verifiedBy', self.verifiedBy);
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                    }
                };
                HTTP.post("addvideos", data, config)
                        .then(function (response) {
                            self.removeAllFiles();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            submitFile1() {
                var form = $('#categoryForm')[0];
                var data = new FormData(form);
                data.append('file', self.videoFile);
                data.append('categoryId', self.categoryIdSearch);
                data.append('mediaSource', self.mediaSource);
                data.append('mediaStatus', self.mediaStatus);
                data.append('verifiedBy', self.verifiedBy);
//                formData.append('positionSequence' , self.positionSequence);

                $.ajax({
                    url: process.env.ROOT_API + "/addvideos",
                    type: "POST",
                    enctype: "multipart/form-data",
                    crossDomain: true,
                    processData: false,
                    /*contentType: false,*/
                    data: data,
//                    headers: {
//                        Accept: "application/json",
//                        "Access-Control-Allow-Origin": "*",
//                        Authorization: "Bearer " + localStorage.getItem("api_token"),
//                        "Access-Control-Allow-Headers":
//                            "Origin, Content-Type, Authorization,X-Requested-With",
//                        "Cache-Control": "no-cache"
//                    },

                    dataType: "json",
                    success: function (data) {
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    }
                });
            },

            /*saveMediaDetail: function () {
             //                var imageArray = $.serialize(self.images);
             var fields = {
             video: self.videos
             };
             console.log(self.videos);
             $.ajax({
             url: process.env.ROOT_API + "/addvideos",
             type: "POST",
             crossDomain: true,
             data: fields,
             //                    headers: {
             //                        Accept: "application/json",
             //                        "Access-Control-Allow-Origin": "*",
             //                        Authorization: "Bearer " + localStorage.getItem("api_token"),
             //                        "Access-Control-Allow-Headers":
             //                            "Origin, Content-Type, Authorization,X-Requested-With",
             //                        "Cache-Control": "no-cache"
             //                    },
             
             dataType: "json",
             success: function (data) {
             },
             error: function (jqXHR, exception) {
             if (jqXHR.status == 0) {
             self.error = "Remote server can not be reachable";
             } else {
             //redirect to login page if user not authenticated
             if (jqXHR.status == 401) {
             //clear previous data
             //                                localStorage.removeItem("user_obj");
             //                                localStorage.removeItem("api_token");
             //                                localStorage.removeItem("profile_image");
             //EventBus.$emit("logged-in", true, "", "");
             }
             }
             }
             });
             }*/
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/backend/gallery/AddVideos.vue